import { useState, useCallback, useMemo } from 'react';
import type { CartLine } from '../lib/cart';
import { subtotalCents, replaceAt } from '../lib/cart';

/**
 * Hook panier — état React au-dessus de la logique pure de lib/cart.ts.
 * Pas de stockage navigateur (non supporté en artifact) : tout en mémoire de session.
 */
export function useCart() {
  const [lines, setLines] = useState<CartLine[]>([]);

  const add = useCallback((line: CartLine) => {
    setLines((prev) => [...prev, line]);
  }, []);

  const removeAt = useCallback((index: number) => {
    setLines((prev) => prev.filter((_, i) => i !== index));
  }, []);

  const update = useCallback((index: number, line: CartLine) => {
    setLines((prev) => replaceAt(prev, index, line));
  }, []);

  const clear = useCallback(() => setLines([]), []);

  const subtotal = useMemo(() => subtotalCents(lines), [lines]);
  const count = useMemo(() => lines.reduce((n, l) => n + l.quantity, 0), [lines]);

  return { lines, add, removeAt, update, clear, subtotal, count };
}
